/**
 * Servicio de datos para Parámetros de Adelantos en Efectivo.
 *
 * Los endpoints /adelantos/* son proxies en IntraNode que internamente
 * usan centrocardAuthService para autenticarse contra la API externa.
 * El frontend llama al backend propio (con cookie de sesión) sin
 * necesitar conocer credenciales externas.
 *
 * Requirements: 6.2
 *
 * Grupos de afinidad: services/gruposAfinidadService.js (servicio único).
 */

import ApiService from "../apiService";

const BASE = "/adelantos";

const AdelantosService = {
  getReglas: () => ApiService.get(`${BASE}/reglas`),
  getPlanes: () => ApiService.get(`${BASE}/planes`),
  createRegla: (payload) => ApiService.post(`${BASE}/reglas`, payload),
  updateRegla: (id, data) => ApiService.put(`${BASE}/reglas/${id}`, data),
  toggleRegla: (id) =>
    ApiService.request("patch", `${BASE}/reglas/${id}/toggle`),
  deleteRegla: (id) => ApiService.delete(`${BASE}/reglas/${id}`),
};

export default AdelantosService;
